import { useAsyncResource } from 'use-async-resource';
import {Filter, InvoiceData, TableData} from '../models/table-models';
import { Pagination } from './pagination-hooks';

export interface FilterProps {
    filterLabel: string;
    filterValue: string;
}

export interface TableRequestParams {
    'pager.page'?: number;
    'pager.itemsPerPage'?: number;
    filter?: Filter;
    pagination?: Pagination;
}

export const transformTableResponse = (response: string): TableData<[]> => {
    const data = response ? JSON.parse(response) : {};
  
    return {
        items: data.items ?? [],
        pager: data.pager ?? {},
    };
};

export const transformInvoiceResponse = (response: string): InvoiceData<[]> => {
    const data = response ? JSON.parse(response) : {};
    return {
        unpaidInvoices: data.items ?? [],
        paidInvoices: data.items ?? [],
        pager: data.pager ?? {},
    };
};

export const transformNoPagerResponse = <T extends unknown>(response: string): Promise<T> => {
    const data = response && JSON.parse(response);
    return data;
};
export const transformOnlyItemsResponse = <T extends unknown>(response: string): T => {
    const data = response && JSON.parse(response);
    return data.items;
};

export const useTableData = <T extends unknown>(
    tableDataHook: (params: TableRequestParams) => Promise<TableData<T>>,
    pagination: Pagination,
    filter?: Filter
) => {
    return useAsyncResource(tableDataHook, {
        'pager.page': pagination.currentPage,
        'pager.itemsPerPage': pagination.pageSize,
        pagination,
        filter,
    });
};

export const useInvoiceData = <T extends unknown>(
    tableDataHook: (params: TableRequestParams) => Promise<InvoiceData<T>>,
    pagination: Pagination,
    filter?: Filter
) => {
    return useAsyncResource(tableDataHook, {
        'pager.page': pagination.currentPage,
        'pager.itemsPerPage': pagination.pageSize,
        pagination,
        filter,
    });
};
